export const DIRECT_BULK_PURCHASE_STATUS = {
  INVALID_PARAMS: 'INVALID_PARAMS',
  PURCHASE_ERROR: 'PURCHASE_ERROR',
  ORDER_RECEIVED: 'ORDER_RECEIVED',
}
